import { getErrorReducer, getIndexesReducer, getStatusReducer, getSuccessActionType } from "../utils";
import { combineReducers } from "redux";
import { FETCH_PROFESSIONS } from "../constants/professions";
import { Profession } from "../types";
import { Action } from "../models/professions";

function data(state: Profession[] = [], action: Action): Profession[] {
  switch (action.type) {
    case getSuccessActionType(FETCH_PROFESSIONS):
      return action.payload;
    default:
      return state;
  }
}

export default combineReducers({
  status: getStatusReducer([FETCH_PROFESSIONS]),
  error: getErrorReducer([FETCH_PROFESSIONS]),
  indexes: getIndexesReducer(FETCH_PROFESSIONS),
  data,
});
